<template>
  <div>
    <div class="flex flex-wrap my-2">
      <div
        class="md:p-4 lg:p-4 md:mb-3 lg:mb-3 xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-full bg-white"
        v-for="productShop in productShops"
        :key="productShop.id"
      >
        <p class="font-medium float-right">{{ productShop.price }} €</p>
        <router-link :to="{ name: 'product', params: { id: productShop.id } }">
          <img
            v-if="productShop.product_image === null"
            class="h-auto w-full object-cover"
            src="./../../assets/images/no-image.jpg"
            alt="No Image"
          />
          <img
            v-else
            class="h-auto w-full object-cover"
            :src="productShop.product_image"
            alt="Product Image"
          />
        </router-link>
        <div class="flex flex-col py-4">
          <router-link :to="{ name: 'product', params: { id: productShop.id } }">
            <p class="text-base">{{ productShop.name }}</p>
          </router-link>
        </div>
      </div>
      <div class="inline-flex pt-10">
        <button
          class="bg-teal-400 h-10 font-semibold text-white px-2 hover:text-teal-400 hover:bg-white"
          @click="prevPage()"
        >{{ $t('Prev')}}</button>
        <p class="text-center text-teal-400 font-semibold p-3">{{currentPage }} / {{ lastPage }}</p>
        <button
          class="bg-teal-400 h-10 font-semibold text-white px-2 hover:text-teal-400 hover:bg-white"
          @click="nextPage()"
        >{{ $t('Next')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      username: this.$route.params.username,
      productShops: [],
      currentPage: "",
      // pages: 0,
      lastPage: "",
      prevUrl: "",
      nextUrl: "",
      path: "",
    };
  },
  created() {
    this.getProductShops();
  },
  methods: {
    getProductShops() {
      axios
        .get(`${process.env.VUE_APP_API}/shops/${this.username}`)
        .then((response) => {
          //   console.log(response);
          this.productShops = response.data.data;
          this.currentPage = response.data.meta.current_page;
          this.lastPage = response.data.meta.last_page;
          this.nextUrl = response.data.links.next;
          console.log(this.nextUrl);
          this.prevUrl = response.data.links.prev;
          this.path = response.data.meta.path;
          this.first = response.data.links.first;
          this.last = response.data.links.last;
        })
        .catch((error) => console.log(error));
    },
    prevPage() {
      axios.get(`${this.prevUrl}`).then((response) => {
        this.productShops = response.data.data;
        this.currentPage = response.data.meta.current_page;
        // this.pages = response.data.meta.total;
        this.lastPage = response.data.meta.last_page;
        this.nextUrl = response.data.links.next;
        this.prevUrl = response.data.links.prev;
        // console.log(this.nextUrl);
        // console.log(this.prevUrl);
        // console.log(this.lastPage);
      });
    },
    nextPage() {
      axios.get(`${this.nextUrl}`).then((response) => {
        this.productShops = response.data.data;
        this.currentPage = response.data.meta.current_page;
        // this.pages = response.data.meta.total;
        this.lastPage = response.data.meta.last_page;
        this.nextUrl = response.data.links.next;
        this.prevUrl = response.data.links.prev;
      });
    },
  },
};
</script>

<style>
</style>